import { getOnlinePay } from "utils/api";

export const queryList = async (params) => {
  return await getOnlinePay("/payment/list", {
    page: 0,
    size: 20,
    is_opt: true,
    sort: "created,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await getOnlinePay("/payment/list", {
    output: "csv",
    ...params,
  });
};
